import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import { ShieldCheck, Zap, Globe, Mail } from 'lucide-react';
import Logo from '../img/logo.png';
import './SetupIntegrations.css';

export default function SetupIntegrations() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Set Up Integrations – Revexia AI</title>
        <meta name="description" content="Connect your store and DMs to Revexia" />
      </Helmet>

      <div className="setup-page-wrapper">
        <div className="setup-bg-blob setup-bg-blob-1" />
        <div className="setup-bg-blob setup-bg-blob-2" />

        <Link to="/" className="setup-brand-logo">
          <img src={Logo} alt="Revexia" className="setup-logo-image" />
        </Link>

        <div className="setup-card-container">
          <div className="setup-card">
            <div className="setup-card-top-line" />

            <div className="setup-header">
              <img src={Logo} alt="Revexia" className="setup-header-logo" />
              <h2 className="setup-title">
                Let&rsquo;s connect your store and DMs
              </h2>
              <p className="setup-subtitle">
                Revexia reads your ManyChat conversations and Shopify visits to
                show you which customers are most likely to buy right now
              </p>
            </div>

            <button
              className="setup-cta-btn"
              onClick={() => navigate('/integrations')}
            >
              Set Up Integrations
            </button>

            <div className="setup-email-hint">
              <Mail size={13} />
              <span>Follow the instructions sent via email</span>
            </div>

            <footer className="setup-footer">
              <div className="setup-security-badge">
                <ShieldCheck size={13} />
                <span>AES-256 Encrypted Connection</span>
              </div>
              <div className="setup-footer-links">
                <button className="setup-footer-link">Privacy</button>
                <span>•</span>
                <button className="setup-footer-link">Terms</button>
                <span>•</span>
                <button className="setup-footer-link">Contact</button>
              </div>
            </footer>
          </div>

          <div className="setup-hints">
            <div className="setup-hint">
              <Zap size={13} className="setup-hint-icon blue" />
              <p className="setup-hint-text">98.2% Forecast Accuracy</p>
            </div>
            <div className="setup-hint">
              <Globe size={13} className="setup-hint-icon purple" />
              <p className="setup-hint-text">Global Node Status: Optimal</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}